import { isGamedistributionApp } from "~/utils/misc";

export default function playSound(soundName) {
  // Return if not loaded yet
  if (is.undefined(soundHash[soundName])) {
    return;
  }

  // Play sound
  _.delay(() => {
    try{
      soundHash[soundName].play();
    } catch(e) {}
  }, 0)
}



// WEBPACK FOOTER //
// ./src/utils/playSound.js